import { apiRequest } from "util/services";

/** Card on file, free Qualified Prospects left and invoices of the usage subscription. */
export async function fetchProspectAccountBilling() {
  const res = await apiRequest(
    "subscriptions/sonic-prospect/self-serve/status",
    "POST",
    {},
    true,
  );
  if (!res || res.error || res.cancel) return null;
  return res;
}

/** Stripe Customer Portal of the usage subscription (card, invoices, tax). */
export async function openProspectCardPortal({
  returnPath = "/settings/plan",
} = {}) {
  const origin = window.location.origin;
  const path = returnPath.startsWith("/") ? returnPath : `/${returnPath}`;
  const res = await apiRequest(
    "subscriptions/sonic-prospect/self-serve/portal",
    "POST",
    { return_url: `${origin}${path}` },
    true,
  );
  if (!res?.url) {
    throw new Error(res?.error || "STRIPE_PORTAL_FAILED");
  }
  return res.url;
}
